
import { KoDate, KoForm, KoFormBuilder, KoLoader, KoSelect, KoTextArea,CURRENCIES, KoToast, Upload} from 'packages';
import { AssetsAPI } from 'pages/workspace/process/assets/assets.service';
import React, { useCallback, useEffect, useState } from 'react';
import styles from './paymentRecived.module.scss';
import KoIcon from '@kwapio/icons';
import { getCookie } from 'shared/utils/cookies';

const CustomerAdvanceCurd = ({form, handleFinish, initialValues }) => {
  // const [form] =KoForm.useForm();
  const [customersList, setDataList] = useState();
  const [isLoading, setLoading] = useState(false);


  useEffect(() => {
    getClients();
  }, []);

  const getClients = () => {
    setLoading(true);
    AssetsAPI.getClients().then(
      (data) => {
        setLoading(false);
        setDataList(data['customers']);
      },
      (err) => {
        setLoading(false);
      }
    );
  };
  const Customers = ({ value, onChange }) =>
    <KoSelect
      value={value}
      showSearch
      mode="multiple"
      optionFilterProp="label"
      placeholder="Select customer"
      onChange={onChange}
      options={customersList?.map(cus => ({
        label: cus?.companyName || 'Unnamed Customer',
        value: cus?.customerId
      }))}
      loading={!customersList?.length}
    />;

  const Date = ({ value, onChange }) => {
    return (
      <KoDate
        value={value}
        format={'DD-MMM-YYYY'}
        daysAgo={0}
        onChange={v => onChange(v)}
      />
    );
  };

  const Currency = ({ value, onChange }) =>
    <KoSelect value={value}
      showSearch
      onChange={v => onChange(v)}
      placeholder='Select currency'
      options={CURRENCIES?.map((currency) => ({
        label: currency?.code + '-' + currency?.name,
        value: currency?.code
      }))} />;


    
  const Taxes = [
    { label: 'Non-Texable', value: 'non-texable' },
    { label: 'IGST0 [0%]', value: '0' },
    { label: 'IGST5 [5%]', value: '5' },
    { label: 'IGST10 [10%]', value: '10' }
  ];
  const Tax  = ({ value, onChange }) =>
    <KoSelect value={value}
      onChange={v => onChange(v)}
      showSearch
      allowClear
      placeholder='Select a Tax'
      options={Taxes?.map((value) => ({
        label: value.label,
        value: value?.value
      }))}
    />;

  const Throught = [
    { label: 'Gay Pay', value: 'gaypay' },
    { label: 'Bank Account', value: 'bankaccount' },
    { label: 'Phone Pay', value: 'phonepay' },
    { label: 'Paytm', value: 'paytm' }
  ];
    
  const PaidThrough = ({ value, onChange }) =>
    <KoSelect value={value}
      onChange={v => onChange(v)}
      showSearch
      allowClear
      placeholder='Choose Paid Through'
      options={Throught?.map((value) => ({
        label: value.label,
        value: value?.value
      }))}
    />;

  const wayDeposite = [
    { label: 'Equity', value: 'equity' },
    { label: 'Stock', value: 'stock' },
    { label: 'Fixed Assets', value: 'assets' },
    { label: 'Cash', value: 'cash' }
  ];

  const Deposite = ({ value, onChange }) =>
    <KoSelect value={value}
      onChange={v => onChange(v)}
      showSearch
      allowClear
      placeholder='Choose Paid Through'
      options={wayDeposite?.map((value) => ({
        label: value.label,
        value: value?.value
      }))}
    />;
    

  const props = {
    name: 'files',
    multiple: true,
    action: `${process.env.REACT_APP_PROXY_HOST}/api/v1/org/upload`,
    data: { module: 'documents'},
    headers: {
      Authorization: `Bearer ${getCookie("accessToken")}`
    },

    onChange(info) {
      if (info.file.status !== 'uploading') {
      }
      if (info.file.status === 'done') {
        KoToast.success(`${info.file.name} file uploaded successfully`);
      } else if (info.file.status === 'error') {
        KoToast.error(`${info.file.name} file upload failed.`);
      }
    }};

  const normFile = (e) => {
    return e?.file;
  };


  const uploadButton = (
    <div className={styles.dndArea}>
      <KoIcon name='AttachmentOutlined' />
      <div>CustomerAdvance Attach File</div>
    </div>

  );
  const onRemoveFile = (d) => {
    console.log();
  };


  const meta = {
    columns: 4,
    formItemLayout: null,
    initialValues: {},
    colon: true,
    fields: [
      { key: 'customer', label: 'Customer Name', colSpan: 2, widget: Customers },
      { key: 'description', widget: KoTextArea, label: 'Description of Supply', colSpan: 6},
      { key: "currency", label: "Currency",  colSpan: 2, widget: Currency },
      { key: "amount", label: "Amount", widget: "number", colSpan: 2, rules: [
        {
          required: true,
          message: `Please enter amount.`
        }
      ]},
      { key: 'bankcharges', label:'Bank Charges (if any)',  colSpan: 2},
      { key: 'tax', label: 'Tax', colSpan: 2, widget: Tax , placeholder: 'Enter a Tax'},
      { key: 'startDate', label: 'Payment Date', colSpan: 2, widget: Date },
      { key: 'payment', label: 'Payment#' , colSpan: 2, rules: [
        {
          required: true,
          message: `Please enter payment.`
        }
      ]},
      { key: 'paidthrough', label: 'Payment Mode', colSpan: 2, widget: PaidThrough },
      { key: 'deposite', label: 'Deposite To', colSpan: 2, widget: Deposite },
      { key: 'reference', label: 'Reference#' , colSpan: 2},
      { key: 'description', widget: KoTextArea, label: 'Notes (Internal use. Not visible to customer)', colSpan: 6}
    ]};




  const handleSubmit =useCallback((values)=>{
    console.log(values);
  },[form]);


  
  return (
    <div  className={styles.wrapper}>
      {isLoading&& <KoLoader/>}
      <KoForm  form={form} layout="vertical" onFinish={handleSubmit} onSubmit={handleSubmit} >
        <div className={styles.attachments}>
          {/* <div className={styles.attachmentsArea}>
            <Driver DeleteFile={false} action={true} fileType={initialValues?.documents?.aadharDetails?.file?.type} filePath={initialValues?.documents?.aadharDetails?.file.url} handleDelete={() => onRemoveFile(initialValues?.documents?.aadharDetails?.file)} />
          </div> */}
        
          <KoForm.Item
            name={"file"}
            valuePropName={"file"}
            getValueFromEvent={normFile}>

            <Upload {...props}
              className={styles.card}
              onRemove={onRemoveFile}
              showUploadList={{showPreviewIcon : false}}
              showPreviewIcon={true}
              listType="picture-card"
            >
              {uploadButton}
            </Upload>
          </KoForm.Item>
        </div>
        <KoFormBuilder form={form} meta={meta} />
      </KoForm></div>
  );
};
export default CustomerAdvanceCurd;